import { styled } from 'styled-components'
import theme from '../../../theme'

export const HelpTextWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: start;
  background-color: ${theme.color.grey4};
  padding: ${theme.spacing.medium};
  gap: ${theme.spacing.medium};
`
